import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { Navbar } from "@/components/landing/Navbar";
import { FooterSection } from "@/components/landing/FooterSection";
import { ArrowRight } from "lucide-react";

const posts = [
  {
    slug: "make-money-500-followers",
    title: "How to Make Money With 500 Followers (The Small Creator's Guide)",
    description: "You don't need millions of followers to earn a living online. Learn proven strategies small creators use to monetise audiences of 500 or fewer.",
    date: "March 18, 2026",
    readTime: "8 min read",
  },
  {
    slug: "ai-tools-content-creators-2026",
    title: "The Best AI Tools for Content Creators in 2026",
    description: "A curated breakdown of the most impactful AI tools helping creators write scripts, build products, and grow faster in 2026.",
    date: "March 15, 2026",
    readTime: "10 min read",
  },
  {
    slug: "create-digital-product-one-day",
    title: "How to Create a Digital Product in One Day",
    description: "Step-by-step guide to going from zero to a sellable digital product in under 24 hours using AI-powered tools.",
    date: "March 12, 2026",
    readTime: "7 min read",
  },
  {
    slug: "email-marketing-content-creators",
    title: "Email Marketing for Content Creators: The Complete Guide",
    description: "Why every creator needs an email list, and exactly how to build, nurture, and monetise one — even if you're starting from scratch.",
    date: "March 9, 2026",
    readTime: "12 min read",
  },
];

const Blog = () => {
  return (
    <>
      <Helmet>
        <title>Blog | AI StoryCraft Studio</title>
        <meta name="description" content="Actionable guides and strategies for content creators looking to monetise their audience with AI-powered tools." />
        <link rel="canonical" href="https://ai-storycraft-studio.com/blog" />
      </Helmet>
      <Navbar />
      <main className="pt-24 pb-16 min-h-screen" style={{ background: "#FFFFFF" }}>
        <div className="max-w-[820px] mx-auto px-4 md:px-6">
          <h1 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold mb-3" style={{ color: "#111827" }}>
            Blog
          </h1>
          <p className="text-lg mb-12" style={{ color: "#6B7280" }}>
            Actionable guides for creators who want to turn content into income.
          </p>
          <div className="flex flex-col gap-8">
            {posts.map((post) => (
              <Link
                key={post.slug}
                to={`/blog/${post.slug}`}
                className="group block p-6 md:p-8 rounded-2xl transition-all hover:shadow-lg"
                style={{ background: "#F9FAFB", border: "1px solid #E5E7EB" }}
              >
                <div className="flex items-center gap-3 text-sm mb-3" style={{ color: "#9CA3AF" }}>
                  <span>{post.date}</span>
                  <span>·</span>
                  <span>{post.readTime}</span>
                </div>
                <h2 className="font-display text-xl md:text-2xl font-bold mb-2 group-hover:text-[#7C3AED] transition-colors" style={{ color: "#111827" }}>
                  {post.title}
                </h2>
                <p className="mb-4" style={{ color: "#6B7280" }}>{post.description}</p>
                <span className="inline-flex items-center gap-1.5 text-sm font-semibold" style={{ color: "#7C3AED" }}>
                  Read article <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                </span>
              </Link>
            ))}
          </div>
        </div>
      </main>
      <FooterSection />
    </>
  );
};

export default Blog;
